/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { OffsetDateTime } from "@freightsimple/time/branded-types";

import { mapValues } from "../runtime";
import type { TrackingSource } from "./TrackingSource";
import {
  TrackingSourceFromJSON,
  TrackingSourceFromJSONTyped,
  TrackingSourceToJSON,
  TrackingSourceToJSONTyped,
} from "./TrackingSource";

/**
 *
 * @export
 * @interface TrackingLine
 */
export interface TrackingLine {
  /**
   *
   * @type {string}
   * @memberof TrackingLine
   */
  trackingLineId?: string;
  /**
   *
   * @type {OffsetDateTime}
   * @memberof TrackingLine
   */
  createdAt?: OffsetDateTime;
  /**
   *
   * @type {string}
   * @memberof TrackingLine
   */
  shipmentId?: string;
  /**
   *
   * @type {OffsetDateTime}
   * @memberof TrackingLine
   */
  timestamp?: OffsetDateTime;
  /**
   *
   * @type {string}
   * @memberof TrackingLine
   */
  message?: string;
  /**
   *
   * @type {TrackingSource}
   * @memberof TrackingLine
   */
  trackingSource?: TrackingSource;
  /**
   *
   * @type {string}
   * @memberof TrackingLine
   */
  manualCreatedBy?: string;
  /**
   *
   * @type {string}
   * @memberof TrackingLine
   */
  sourceDetails?: string;
  /**
   *
   * @type {string}
   * @memberof TrackingLine
   */
  sourceLink?: string;
  /**
   *
   * @type {string}
   * @memberof TrackingLine
   */
  trackingStatus?: string;
  /**
   *
   * @type {string}
   * @memberof TrackingLine
   */
  carrierIdentifier?: string;
  /**
   *
   * @type {OffsetDateTime}
   * @memberof TrackingLine
   */
  eventTime?: OffsetDateTime;
}

/**
 * Check if a given object implements the TrackingLine interface.
 */
export function instanceOfTrackingLine(value: object): value is TrackingLine {
  return true;
}

export function TrackingLineFromJSON(json: any): TrackingLine {
  return TrackingLineFromJSONTyped(json, false);
}

export function TrackingLineFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): TrackingLine {
  if (json == null) {
    return json;
  }
  return {
    trackingLineId:
      json["trackingLineId"] == null ? undefined : json["trackingLineId"],
    createdAt: json["createdAt"] == null ? undefined : json["createdAt"],
    shipmentId: json["shipmentId"] == null ? undefined : json["shipmentId"],
    timestamp: json["timestamp"] == null ? undefined : json["timestamp"],
    message: json["message"] == null ? undefined : json["message"],
    trackingSource:
      json["trackingSource"] == null
        ? undefined
        : TrackingSourceFromJSON(json["trackingSource"]),
    manualCreatedBy:
      json["manualCreatedBy"] == null ? undefined : json["manualCreatedBy"],
    sourceDetails:
      json["sourceDetails"] == null ? undefined : json["sourceDetails"],
    sourceLink: json["sourceLink"] == null ? undefined : json["sourceLink"],
    trackingStatus:
      json["trackingStatus"] == null ? undefined : json["trackingStatus"],
    carrierIdentifier:
      json["carrierIdentifier"] == null ? undefined : json["carrierIdentifier"],
    eventTime: json["eventTime"] == null ? undefined : json["eventTime"],
  };
}

export function TrackingLineToJSON(json: any): TrackingLine {
  return TrackingLineToJSONTyped(json, false);
}

export function TrackingLineToJSONTyped(
  value?: TrackingLine | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    trackingLineId: value["trackingLineId"],
    createdAt: value["createdAt"],
    shipmentId: value["shipmentId"],
    timestamp: value["timestamp"],
    message: value["message"],
    trackingSource: TrackingSourceToJSON(value["trackingSource"]),
    manualCreatedBy: value["manualCreatedBy"],
    sourceDetails: value["sourceDetails"],
    sourceLink: value["sourceLink"],
    trackingStatus: value["trackingStatus"],
    carrierIdentifier: value["carrierIdentifier"],
    eventTime: value["eventTime"],
  };
}
